<ng-template #createProject let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">Create New Project</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="card" style="box-shadow: none">
        <div class="card-header border-0">
          <div class="progress progress-step-arrow progress-info">
            @for (step of steps; track step; let i = $index) {
              <div class="progress-bar w-100" [ngClass]="i === currentStep+1 ? 'next' : i > currentStep+1 ? 'bg-light text-body' : ''">{{ step }}</div>
            }
          </div>
        </div>
        <div class="card-body border-0">
          @switch (currentStep) {
            @case (0) {
              <div>
                <form [formGroup]="createForm">
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-6">
                        <label for="name" class="form-label">Project name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="name" placeholder="Enter project name" required formControlName="name" [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
                        <div class="invalid-feedback"> Please enter project name </div>
                      </div>
                      <div class="col-6">
                        <label for="roles" class="form-label">Parent Project</label>
                        <ng-select [items]="projects" bindLabel="name" bindValue="id" [loading]="loading" placeholder="Select parent project" [(ngModel)]="selectedProject" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !selectedProject }">
                          <ng-template ng-loadingspinner-tmp>
                            <div class="lds-ellipsis">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </ng-template>
                        </ng-select>
                        <div class="invalid-feedback"> Please select a parent project </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="email" class="form-label">Description</label>
                    <quill-editor [styles]="{height: '250px'}" [(ngModel)]="description" [ngModelOptions]="{standalone: true}" class="d-block"></quill-editor>
                  </div>
                </form>
              </div>
            }
            @case (1) {
              <div>
                <div class="row g-4 mb-3">
                  <div class="col-sm-auto">
                    <div>
                      @if (submitted && selectedUsers.length === 0) {
                        <p class="text-danger">No users has been selected, you must select at least one.</p>
                      }
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="d-flex justify-content-sm-end">
                      <div class="search-box ms-2">
                        <input type="text" class="form-control search" placeholder="Search..." [(ngModel)]="searchText" (input)="onSearch()">
                        <i class="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive table-card mt-3 mb-1">
                  <table class="table">
                    <thead>
                      <tr class="bg-light text-muted">
                        <th scope="col" style="width: 50px;"></th>
                        <th class="sort" listsortable="first_name" (listsort)="onSort($event)">First Name</th>
                        <th class="sort" listsortable="last_name" (listsort)="onSort($event)">Last Name</th>
                        <th class="sort" listsortable="email" (listsort)="onSort($event)">Email</th>
                        <th>Roles</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (loading) {
                        <tr>
                          <td colspan="6" class="text-center">
                            <app-loading-spinner></app-loading-spinner>
                          </td>
                        </tr>
                      }
                      @if (!loading && users && users.length > 0) {
                        @for (client_user of users; track client_user) {
                          <tr>
                            <th scope="row">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="checkAll" value="{{client_user.id}}" [(ngModel)]="client_user.state" (change)="addRemoveMembers(client_user)">
                              </div>
                            </th>
                            <td>
                              <ngb-highlight [result]="client_user.user.person.first_name" [term]="searchText"></ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="client_user.user.person.last_name" [term]="searchText"></ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="client_user.user.email" [term]="searchText"></ngb-highlight>
                            </td>
                            <td class="status">
                              @for (role of client_user.roles; track role) {
                                <span
                                  class="badge text-uppercase me-1"
                                  [ngClass]="role === 'ADMIN' ? 'bg-danger-subtle text-danger' : role === 'EDITOR' ? 'bg-warning-subtle text-warning' : 'bg-success-subtle text-success'">
                                  {{ role }}
                                </span>
                              }
                            </td>
                            <td class="status">
                              <span
                                class="badge text-uppercase"
                                [ngClass]="client_user.status === 'ACTIVE' ? 'bg-success-subtle text-success' : client_user.status === 'SUSPENDED'? 'bg-danger-subtle text-danger':'bg-warning-subtle text-warning'">
                                {{ client_user.status }}
                              </span>
                            </td>
                          </tr>
                        }
                      }
                      @if (!loading && users && users.length === 0) {
                        <tr>
                          @if (searchText === '') {
                            <td colspan="6" class="text-center">No new users were found to assign for this project. (as creator you will be assign by default)</td>
                          }
                          @if (searchText !== '') {
                            <td colspan="6" class="text-center">No search results were found.</td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                @if (users.length > 0 && !loading) {
                  <div class="row justify-content-md-between align-items-md-center">
                    <div class="col col-sm-6">
                      <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalUsers}} entries </div>
                    </div>
                    <div class="col col-sm-6">
                      <div class="text-sm-right float-end listjs-pagination">
                        <ngb-pagination [collectionSize]="totalUsers" [(page)]="currentPage" [pageSize]="pageSize"></ngb-pagination>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            @case (2) {
              <div>
                <div class="text-muted">
                  <div class="pt-3 border-top border-top-dashed mt-4">
                    <div class="row">
                      <div class="col-lg-3 col-sm-6">
                        <div>
                          <p class="mb-2 text-uppercase fw-medium">Project Name:</p>
                          <h5 class="fs-15 mb-0">{{ f['name'].value }}</h5>
                        </div>
                      </div>
                      <div class="col-lg-3 col-sm-6">
                        <div>
                          <p class="mb-2 text-uppercase fw-medium">Create Date:</p>
                          <h5 class="fs-15 mb-0">{{ today | date: 'd MMM, y' }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pt-3 border-top border-top-dashed mt-4 quill-view">
                    <h6 class="mb-3 fw-semibold text-uppercase">Description</h6>
                    @if (description) {
                      <quill-editor classes="border-0" [(ngModel)]="description" [readOnly]="true" [modules]="{toolbar:false}"></quill-editor>
                    }
                    @if (!description) {
                      <p>No description has been added to the project.</p>
                    }
                  </div>
                  <div class="pt-3 border-top border-top-dashed mt-4">
                    <h6 class="mb-3 fw-semibold text-uppercase">Assigned Members</h6>
                    @if (selectedUsers.length > 0) {
                      <table class="table table-borderless align-middle table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th scope="col">First name</th>
                            <th scope="col">Last name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Roles</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (client_user of selectedUsers; track client_user) {
                            <tr>
                              <td>{{ client_user.user.person.first_name }}</td>
                              <td>{{ client_user.user.person.last_name }}</td>
                              <td>{{ client_user.user.email }}</td>
                              <td>
                                @for (role of client_user.roles; track role) {
                                  <span
                                    class="badge text-uppercase me-1"
                                    [ngClass]="role === 'ADMIN' ? 'bg-danger-subtle text-danger' : role === 'EDITOR' ? 'bg-warning-subtle text-warning' : 'bg-success-subtle text-success'">
                                    {{ role }}
                                  </span>
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                    @if (selectedUsers.length === 0) {
                      <p>No members has been assign to this project.</p>
                    }
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
    <div class="modal-footer">
      @if (currentStep > 0) {
        <div class="me-auto">
          <button (click)="backStep()" class="btn btn-primary btn-load">Back</button>
        </div>
      }
      <div class="text-end">
        <button (click)="currentStep === steps.length-1 ? onSubmit() : nextStep()" class="btn btn-primary btn-load">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ currentStep < steps.length-1 ? 'Next' : 'Create' }} </span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        <h4 class="mb-3 mt-4">Project has been created successfully.</h4>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errorModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" style="width:150px;height:150px"></lord-icon>
        <h4 class="mb-3 mt-4">No Subscription Found</h4>
        <p class="text-muted fs-15 mb-4">You can not create project without an active subscription!</p>
      </div>
    </div>
  </div>
</ng-template>